import { useQuery } from '@apollo/client';
import { Align, Container, Spacer, Text } from '@loomhq/lens';
import React from 'react';

import GetUserFollowedStreams from 'creators/follows/GetUserFollowedStreams.graphql';
import { getUserAvatarThumb } from 'utilities/avatar';
import { getMostCompleteNamePossible } from 'utilities/user';

import MenuLink from './MenuLink';
import SuggestedFollows from './suggested-follows';

import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const FollowsSection = ({
  isCollapsed,
  isMobile,
  navBarIsOpenMobile,
  showTags,
  showProfiles,
}) => {
  const { loading: followsLoading, data: follows } = useQuery(
    GetUserFollowedStreams,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    }
  );

  const ProfileLink = ({ profile, ...props }) => {
    const name = getMostCompleteNamePossible(profile.user);

    return (
      <MenuLink
        icon={
          <UserAvatar
            avatarSrc={getUserAvatarThumb(profile.user.avatars)}
            name={name}
            alt={name}
            avatarSize={3}
          />
        }
        title={name}
        url={`/profile/${profile.user.profile?.profileUrl}`}
        collapsed={isCollapsed}
        isMobileCollapsedNav={isMobile && !navBarIsOpenMobile}
        isReactRouterLink
        shouldDim={!profile.unread}
        {...props}
      />
    );
  };

  const TagLink = ({ tag, ...props }) => (
    <MenuLink
      icon={
        <Container width="1.5rem">
          <Align alignment="center">
            <Text fontWeight="bold">#</Text>
          </Align>
        </Container>
      }
      title={tag.name}
      url={`/tag/${tag.name}`}
      collapsed={isCollapsed}
      isMobileCollapsedNav={isMobile && !navBarIsOpenMobile}
      isReactRouterLink
      shouldDim={!tag.unread}
      {...props}
    />
  );

  if (followsLoading && !follows?.result) {
    return null;
  }

  const followedProfiles = follows.result.profiles;
  const followedTags = follows.result.tags;

  return (
    <>
      {(followedProfiles.length > 0 || followedTags.length > 0) && (
        <>
          <div className={styles.librariesHeading}>
            <Spacer bottom="small" left="xsmall">
              <Text fontWeight="medium" color="bodyDimmed">
                Following
              </Text>
            </Spacer>
          </div>

          {showProfiles &&
            followedProfiles.map(profile => (
              <ProfileLink key={profile.user.id} profile={profile} />
            ))}

          {showTags &&
            followedTags.map(tag => <TagLink key={tag.name} tag={tag} />)}
        </>
      )}

      {(followedProfiles.length > 0 || followedTags.length > 0) && (
        <Spacer top="medium" />
      )}

      <SuggestedFollows
        followedProfiles={followedProfiles}
        followedTags={followedTags}
        ProfileLink={ProfileLink}
        TagLink={TagLink}
        showTags={showTags}
        showProfiles={showProfiles}
      />
    </>
  );
};

export default FollowsSection;
